<!-- 库存上下限 -->
<template>
	<div>
		<div>
			<div class="demo-drawer__content data_action_form">
				<el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
					<v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
						<template slot="tabs" slot-scope="scope">
							<div class="table_content_box">
								<!-- 主要信息 -->
								<div v-if="scope.index == 0">
									<!-- 明细 -->
									<el-form :inline="true" size="mini">
										<div id="operateBtn">
											<el-button type="primary" size="mini" @click="addDetails">新增</el-button>
											<el-button type="primary" size="mini" @click="deleteDetails()">删除</el-button>
											<el-button @click="exportTemplate" size="mini" type="primary">下载模版</el-button>
											<el-button @click="importDetails" size="mini" type="primary">导入明细</el-button>
										</div>
										<el-table ref="mxTableRef" id="mxTable" size="mini" :data="sendDataInfo.movedetailAdds" :height="mxHeight" border style="width: 100%">
											<el-table-column label="操作" width="80">
												<template slot-scope="scope">
													<el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
														<i class="el-icon-thumb"></i>
													</el-radio>
												</template>
											</el-table-column>
											<el-table-column align="center" :prop="formOneValue.entityField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" :label="formOneValue.showField"
															 v-for="(formOneValue,formOneKey) in mxForm" :key="formOneKey" v-if="formOneValue.isShow==1">
												<template slot-scope="scope">
													<!-- 显示通用名称 -->
													<el-input :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgmName'"
															  :disabled="dataActionBox.actionType == 1 && sendDataInfo.movedetailAdds[scope.$index].bgmName != ''"
															  @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField,formOneValue.setField)"
															  v-model="sendDataInfo.movedetailAdds[scope.$index].bgmName" :maxlength="$store.state.inputLength">
														<el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search">
														</el-button>
													</el-input>
													<input :ref="formOneValue.entityField" class="newInput" :min="0" v-else-if="formOneValue.entityField == 'limdHighnum'" type="number"
														   v-model.number="sendDataInfo.movedetailAdds[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength">
													<input :ref="formOneValue.entityField" class="newInput" :min="0" v-else-if="formOneValue.entityField == 'limdLownum'" type="number"
														   v-model.number="sendDataInfo.movedetailAdds[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength">
													<!-- 是否自动维护 -->
													<el-radio-group :ref="formOneValue.entityField" size="mini" v-else-if="formOneValue.entityField == 'auto'"
																	v-model="sendDataInfo.movedetailAdds[scope.$index][formOneValue.entityField]">
														<el-radio-button :label="0">否</el-radio-button>
														<el-radio-button :label="1">是</el-radio-button>
													</el-radio-group>
													<span v-else-if="formOneValue.entityField == 'prodate'">
														<span v-if="scope.row[formOneValue.entityField]">
															{{$common.getLocalTime(scope.row[formOneValue.entityField])}}
														</span>
													</span>
													<span v-else-if="formOneValue.entityField == 'expidate'">
														<span v-if="scope.row[formOneValue.entityField]">
															{{$common.getLocalTime(scope.row[formOneValue.entityField])}}
														</span>
													</span>
													<span v-else>{{sendDataInfo.movedetailAdds[scope.$index][formOneValue.entityField]}}</span>
												</template>
											</el-table-column>
										</el-table>
									</el-form>
								</div>
							</div>
						</template>
					</v-tabs>
				</el-card>
				<div class="foot" style="text-align: center;">
					<div style="text-align: center;">
						<el-button type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
						<el-button type="primary" @click="sendDataAction('sendDataInfo')">保存</el-button>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
			<SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
		</el-dialog>
		<el-dialog title="导入" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
			<initDataUpload :url="url" :errorUrl="'limit/exportFail'" :listShow="true" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
			</initDataUpload>
		</el-dialog>
	</div>
</template>
<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';
	import SearchScheme from "../byComponents/SearchScheme.vue";
	import NP from "number-precision";
	export default {
		name: "stockLimitListAction",
		props: ['actionData'],
		//import引入的组件需要注入到对象中才能使用
		components: {
			SearchScheme,
		},
		data() {
			//这里存放数据
			return {
				dataActionBox: {
					showStatus: false,
					openMode: "ltr" || "rtl",
					boxTitle: "新增" || "编辑",
					actionType: 0, // 0新增，1修改
				},
				selectDataTable: false,
				sendDataInfo: {
					movedetailAdds: [],
				},
				detaislDataInfo: {},
				selectedDetailsIndex: 0,
				storageRoomList: [],
				selectedDetails: [],
				selectGoodsInfo: "",
				formDataList: [],
				tabForm: [],
				mxForm: [],
				footForm: [],
				showTabs: "",
				formDataList: [],
				DialogVisible: false,
				seTitle: "",
				seWidth: "",
				exWidth: "",
				seId: "",
				seIndex: 0,
				seType: "",
				sField: "",
				parentSearchData: {
					movmOutstid: "",
				},
				mxHeight: 0,
				importShow: false,
				importType: "",
				url: "",
			};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {
			"sendDataInfo.movedetailAdds": {
				handler: function (newValue, oldValue) {
					newValue.forEach((item, keys) => {
						if (item.limdHighnum < item.limdLownum) {
							this.$message({
								message: '下限数量不能大于上限数量',
								type: "error",
							});
							item.limdLownum = 0
						}
					})
				},
				deep: true,
			},
		},
		//方法集合
		methods: {
			// 触发组件的提交
			fileSuccess(val) {
			},
			// 关闭弹窗
			closeExcel(val) {
				this.importShow = false
				if (val.list.length > 0) {
					// 清理空数据
					this.sendDataInfo.movedetailAdds = this.sendDataInfo.movedetailAdds.filter(item =>
						item.bgmId !== "" && item.bgmName !== "");
					// 处理新数据并设置默认值
					const processedItems = val.list.map(item => ({
						...item,
						changeNum: item.num,
						newPrice: item.newPrice || 0,
						newPsprice: item.newPsprice || 0
					}));

					// 过滤重复项
					const existingBgmIds = new Set(this.sendDataInfo.movedetailAdds.map(item => item.bgmId));
					const uniqueNewItems = processedItems.filter(item => !existingBgmIds.has(item.bgmId));

					// 添加到列表
					this.sendDataInfo.movedetailAdds.push(...uniqueNewItems);
				}
			},
			exportTemplate() {
				window.location.href = `${window.global_config.BASE_URL}/limit/downDetailExcel`
			},
			importDetails() {
				this.importType = 'limitExportDetail'
				this.url = 'limit/exportDetail'
				this.importShow = true
			},
			addDetails() {
				var flag = false
				if (this.sendDataInfo.movedetailAdds.length > 0) {
					this.sendDataInfo.movedetailAdds.forEach(item => {
						if (item.bgmId == "") {
							flag = true
							this.$nextTick(() => {
								this.selectedDetailsIndex = Number(
									this.sendDataInfo.movedetailAdds.length - 1
								);
								this.tableNextFocus("bgmName", this.selectedDetailsIndex);
								let refsElTable = this.$refs.mxTableRef;
								refsElTable.clearSelection();
								refsElTable.toggleRowSelection(
									this.sendDataInfo.movedetailAdds[this.selectedDetailsIndex]
								);
							});
						}
					})
				}
				if (flag) {
					return
				}
				this.sendDataInfo.movedetailAdds.push({})
				var index = this.sendDataInfo.movedetailAdds.length - 1
				for (const key in this.detaislDataInfo) {
					this.$set(this.sendDataInfo.movedetailAdds[index], key, this.detaislDataInfo[key])
				}
				this.$nextTick(() => {
					this.selectedDetailsIndex = Number(
						this.sendDataInfo.movedetailAdds.length - 1
					);
					this.tableNextFocus("bgmName", this.selectedDetailsIndex);
					let refsElTable = this.$refs.mxTableRef;
					refsElTable.clearSelection();
					refsElTable.toggleRowSelection(
						this.sendDataInfo.movedetailAdds[this.selectedDetailsIndex]
					);
				});
			},
			// 表格切换焦点方法
			tableNextFocus(field, index) {
				this.seIndex = index;
				if (field == "keydown") {
					if (this.sendDataInfo.movedetailAdds[index + 1] != undefined) {
						if (this.$refs["bgmName"] && this.$refs["bgmName"][index + 1]) {
							this.$refs["bgmName"][index + 1].focus();
							this.selectedDetailsIndex = index + 1;
							this.$nextTick(() => {
								let refsElTable = this.$refs.mxTableRef;
								refsElTable.clearSelection();
								refsElTable.toggleRowSelection(
									this.sendDataInfo.movedetailAdds[this.selectedDetailsIndex]
								);
							});
						}
						return;
					}
					this.addDetails();
					return;
				}
				if (this.$refs[field] && this.$refs[field][index]) {
					this.$refs[field][index].focus();
				}
			},
			changeInputModel(val) {
				if (val != "" || val != undefined) {
					if (this.seType == "bgmName") {
						if (Array.isArray(val)) {
							// 清理空数据
							this.sendDataInfo.movedetailAdds = this.sendDataInfo.movedetailAdds.filter(item =>
								item.bgmId !== "" && item.bgmName !== "");

							// 创建新项目数组
							const newItems = val.map(item => {
								const newItem = { ...item };
								newItem.rgdOldnumber = item.psbkdIsnumber;
								return newItem;
							});

							// 过滤重复项
							const existingBgmIds = new Set(this.sendDataInfo.movedetailAdds.map(item => item.bgmId));
							const uniqueNewItems = newItems.filter(item => !existingBgmIds.has(item.bgmId));

							// 批量创建完整项目对象
							const completeNewItems = uniqueNewItems.map(item => {
								const completeItem = {};
								Object.keys(this.detaislDataInfo).forEach(key => {
									this.$set(completeItem, key, item[key] !== undefined ? item[key] : this.detaislDataInfo[key]);
								});
								return completeItem;
							});

							// 一次性添加所有新项目
							this.sendDataInfo.movedetailAdds.push(...completeNewItems);

							// 更新选中索引
							if (completeNewItems.length > 0) {
								this.selectedDetailsIndex = this.sendDataInfo.movedetailAdds.length - 1;
							}
						} else if (typeof val === 'object' && val !== null) {
							const detail = this.sendDataInfo.movedetailAdds[this.selectedDetailsIndex];
							Object.keys(detail).forEach(key => {
								if (val[key] != null && val[key] != undefined && val[key] !== "") {
									this.$set(detail, key, val[key]);
								} else {
									this.$set(detail, key, detail[key]);
								}
							});
						}
					}
				}
				this.DialogVisible = false;
			},
			// 检索Id, 索引(表格中), 标识
			openSearch(sId, index, type, sField) {
				this.parentSearchData.bgmName = this.sendDataInfo.movedetailAdds[index].bgmName
				this.DialogVisible = true;
				this.seId = sId;
				this.seIndex = index;
				this.seType = type;
				this.sField = sField;
			},
			getSearchName(e) {
				console.log(e);
				this.seTitle = e;
			},
			getSeWidth(e) {
				console.log(e);
				this.seWidth = e + "%";
			},
			// 获取所有可用库房列表
			async getAllStorageRoom() {
				let responseData = await this.$http.getAllStorageRoom();
				if (responseData.status == 200) {
					this.storageRoomList = responseData.result;
				} else {
					this.$message({
						message: responseData.message,
						type: "error",
					});
				}
			},
			initActionBox(sendDataInfo) {
				this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
					.then(() => {
						this.$emit('drawerCancel', 0)
						this.init();
					})
					.catch(() => {
						// this.$message({
						//     type: 'info',
						//     message: '取消关闭'
						// });
					});
			},
			init() {
				for (let key in this.sendDataInfo) {
					this.sendDataInfo[key] = "";
				}
				this.sendDataInfo.movedetailAdds = [];
			},
			async isShowData(name, value) {
				this.sendDataInfo[name] = value;
			},

			openBox() {
				this.dataActionBox.actionType = this.actionData.cate
				this.formDataList = this.actionData.formData
				var oldData = this.actionData.oldData
				this.showTabs = this.actionData.formData[0].jciName
				this.filterMainField()
				this.init();
				if (this.dataActionBox.actionType == 0) {
					this.dataActionBox.boxTitle = "新增信息";
					this.dataActionBox.openMode = "ltr";
				} else if (this.dataActionBox.actionType == 1) {
					this.dataActionBox.boxTitle = "编辑信息";
					this.dataActionBox.openMode = "rtl";
					this.sendDataInfo.movedetailAdds[0] = oldData;
				} else {
					this.dataActionBox.boxTitle = '查看信息'
					var dataInfo = JSON.parse(JSON.stringify(oldData))
					for (let key in dataInfo) {
						this.sendDataInfo[key] = dataInfo[key]
					}
				}
				this.$nextTick(() => {
					setTimeout(() => {
						if (this.dataActionBox.actionType != 2) {
							this.mxHeight = this.$common.getBtnHeight()
						} else {
							this.mxHeight = this.$common.getHeight()
						}
					}, 16.7)
				})
			},
			sendDataAction() {
				this.sub();
			},
			async sub() {
				let sendData = JSON.parse(
					JSON.stringify(this.sendDataInfo.movedetailAdds)
				);
				if (this.dataActionBox.actionType == 0) {
					var responseData = await this.$http.addStockLimit(sendData);
				} else {
					var responseData = await this.$http.setStockLimit(sendData);
				}

				if (responseData.status == 200) {
					this.$emit('drawerCancel', 1)
					this.init();
					this.$message.success("操作成功");
				} else {
					this.$message({
						message: responseData.message,
						type: "error",
					});
				}
			},
			deleteDetails(index) {
				if (this.sendDataInfo.movedetailAdds.length > 0) {
					this.sendDataInfo.movedetailAdds.splice(this.selectedDetailsIndex, 1);
					this.selectedDetailsIndex = 0;
				} else {
					return this.$message({
						message: "暂无可删除明细",
						type: "warning",
					});
				}
			},
			// 过滤表单不同类型
			filterMainField() {
				var mainFormList = []
				this.formDataList.forEach(item => {
					if (item.jciType == 2) {
						mainFormList.push(item)
						this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
						this.mxForm.forEach(item1 => {
							if (item1.fieldType == 'number') {
								this.$set(this.detaislDataInfo, item1.entityField, 0)
							} else if (item1.fieldType == 'search' && item1.setField) {
								var arr = item1.setField.split(',')
								arr.forEach(item2 => {
									this.$set(this.detaislDataInfo, item2, "")
								})
							} else {
								this.$set(this.detaislDataInfo, item1.entityField, "")
							}
						})
					} else if (item.jciType == 3) {
						this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
					}
				})
				mainFormList.forEach((key, i) => {
					this.tabForm[i] = JSON.parse(JSON.stringify(key))
					this.tabForm[i].jurconfigform = []
					for (let index = 0; index < key.jurconfigform.length; index++) {
						if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
							.jurconfigform[index])
					}
				})
				var arr = [{ entityField: "movedetailAdds" }]
				var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
				for (let key in obj) {
					this.$set(this.sendDataInfo, key, obj[key])
				}
			}

		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {
			this.$nextTick(() => {
				this.openBox()
			})
			this.getAllStorageRoom();
		},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() { },
		beforeCreate() { }, //生命周期 - 创建之前
		beforeMount() { }, //生命周期 - 挂载之前
		beforeUpdate() { }, //生命周期 - 更新之前
		updated() { }, //生命周期 - 更新之后
		beforeDestroy() { }, //生命周期 - 销毁之前
		destroyed() { }, //生命周期 - 销毁完成
		activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>
<style scoped>
	.table_button_box {
		height: 200px;
		background-color: red;
	}

	.table_content_box {
		/* height: 500px !important; */
		overflow-y: auto;
	}

	.foot {
		display: flex;
		justify-content: center;
		align-items: center;
		/* position: absolute;
				    bottom: -27px;
				    left: 49%;
				    transform: translate(-50%, -50%); */
		width: 100%;
		background: #fff;
		padding: 14px 0;
		z-index: 999;
	}

	.foot .el-form {
		margin-left: 20px;
	}

	.foot .el-form .el-form-item {
		margin-bottom: 0;
	}
	#mxTable .el-form-item--mini.el-form-item,
	#mxTable .el-form-item--small.el-form-item {
		margin-bottom: 0;
	}
	.newInput {
		-webkit-appearance: none;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: inherit;
		height: 28px;
		line-height: 28px;
		outline: 0;
		padding: 0 15px;
		transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
		width: 100%;
	}
</style>